import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class MainService {
  tokens
  constructor(private http: HttpClient) {}
  token=localStorage.getItem('access_token')
  // httpOptions1 = { 
  //   headers: new HttpHeaders({
     
  //     Authorization:'Bearer ' + this.token
  //   })
  // };

  addList(id,data): Observable<any>{
    let formData:FormData = new FormData();
    formData.append('id', id);
    formData.append('file', data);
  

    return this.http.post(environment.baseUrl + 'dishUpload' , formData);
}

  getReturant(id): Observable<any>{
    return this.http.get(environment.baseUrl + 'restaurant?id=' + id);
  }
// 
getallAllergens() {
  return this.http.get(environment.baseUrl + 'allAllergens');
}
getallDiestpref() {
  return this.http.get(environment.baseUrl + 'alldp');
}
getallCategory(id) {
  return this.http.get(environment.baseUrl + 'restaurantDishType?restaurant_id=' + id);
}
  getReturantDetails(id) {
    return this.http.get(environment.baseUrl + 'restaurantAllDishes?id=' + id);
  }
  generateQrcode(id) {
    return this.http.get(environment.baseUrl + 'generateRestoQr?restaurant_id=' + id);
  }
  deleteDish(id,restaurant_id) {
    const data={
      dish_id : id,
      id     : restaurant_id,
      status : "Deleted"
    }
    return this.http.put(environment.baseUrl + 'dishStatusChange' , data);
  }
  updateList(data){

    return this.http.put(environment.baseUrl + 'updateRestaurantDish' , data);
  }
  activs
  AcitveInactiveDish(value,restaurant_id,valueId) { 
    if(value=="Active"){
      this.activs={
        dish_id : valueId,
        id     : restaurant_id,
        status : "Inactive"
      }
    }
    else if(value == "Inactive"){
      this.activs={
        dish_id : valueId,
        id     : restaurant_id,
        status : "Active"
      }
    }
  
    return this.http.put(environment.baseUrl + 'dishStatusChange' , this.activs);
  }


}
